import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const AddTrainingEnrollment = createAsyncThunk(
  "AgentTrainingIssues/AddTrainingEnrollment",
  async (data, thunkAPI) => {
    let { schema, handleSuccess, handleError } = data;
    try {
      const resp = await axios.post(
        `${process.env.REACT_APP_BASE_URL}api/users/mentorship/enrollment`,
        schema,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (handleSuccess && resp?.data) {
        handleSuccess();
      }
      return { ...resp.data, mentor: data.mentor };
    } catch (error) {
      if (error.response) {
        if (handleError) {
          handleError(
            error.response.data.errorMessage || error.response.data.message
          );
        }
        return thunkAPI.rejectWithValue(
          error.response.data.errorMessage || error.response.data.message
        );
      } else {
        if (handleError) {
          handleError(error.message);
        }
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
